export default __webpack_public_path__ + "static/media/iwonder-dreamheaven.2fcbf12f.mp3";